import { StyleSheet } from 'react-native';
import React from "react";
import { GraphBookingPresenceWeekChart, GraphCheckinTime, GraphTotalBookingsWeek } from 'components/management/molecules/graphs'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import GraphDateRange, { formatDateRange } from 'components/atoms/GraphDateRange'
import { getChartDateRange } from 'services/redux/management/reducers'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const EmployeeStatistics = ({ employee }) => {
	
	const _graphDateRange = useSelector( state => {
		return getChartDateRange(state);
	} )
	
	const graphs = [
		<GraphCheckinTime
			dateRange={ formatDateRange( _graphDateRange ) }
			employee={[
				employee.guid
			]}
		/>,
		<GraphTotalBookingsWeek
			dateRange={ formatDateRange( _graphDateRange ) }
			employee={[
				employee.guid
			]}
		/>,
		<GraphBookingPresenceWeekChart
			dateRange={ formatDateRange( _graphDateRange ) }
			employee={[
				employee.guid
			]}
		/>,
	]
	
	return (
		<VStack>
			<GraphDateRange containerStyle={ staticStyles.graphDateRangeMarginTop0 } />
				
			<VStack
				space={ ThemedValues.stackSpace }>
				
				{ graphs }
			</VStack>
		</VStack>
	)
}

const staticStyles = StyleSheet.create({
	graphDateRangeMarginTop0: {
		marginTop: 0,
	},
});

export default EmployeeStatistics
